import { render, staticRenderFns } from "./Containers.vue?vue&type=template&id=3b3ed3d2"
import script from "./Containers.vue?vue&type=script&lang=js"
export * from "./Containers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports